export default __webpack_public_path__ + "static/media/banner.45c603eb.jpg";